import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import Barcode from 'react-barcode'
import {useBrand} from '../../contexts/brand-context'

const OrderBarCode = ({orderNo = '', hasOnlyGiftCards = false, isOnlineOrder}) => {
    const {isGarage} = useBrand()
    
    if (hasOnlyGiftCards) {
        return null
    }

    return (
        <Flex
            display={{base: 'flex', lg: 'none'}}
            flexDirection="column"
            width="100%"
            alignItems="center"
            marginTop="16px"
            sx={{
                '.order-qr-code': {
                    width: '100%',
                    height: 'auto',
                    marginTop: '12px'
                }
            }}
        >
            {/* data-private: barcode encodes the order number (PII) - keep out of LogRocket replays */}
            <Box data-private width="100%">
                <Barcode
                    className="order-qr-code"
                    width={5}
                    height={120}
                    displayValue={false}
                    value={orderNo}
                    margin={0}
                />
            </Box>

            {isOnlineOrder && (
                <Text
                    color="webTypo.textPrimary"
                    fontSize="12px"
                    fontWeight="400"
                    lineHeight="18px"
                    fontFamily="GarageNeue"
                >
                    {isGarage ? (
                        <FormattedMessage
                            id="account_order_detail.label.in_store_return_barcode.garage"
                            defaultMessage="For in store returns, scan the barcode"
                        />
                    ) : (
                        <FormattedMessage
                            id="account_order_detail.label.in_store_return_barcode.dynamite"
                            defaultMessage="For in store returns, scan the barcode"
                        />
                    )}
                </Text>
            )}
        </Flex>
    )
}

OrderBarCode.propTypes = {
    orderNo: PropTypes.string,
    hasOnlyGiftCards: PropTypes.bool,
    isOnlineOrder: PropTypes.bool
}

export default OrderBarCode
